import React, { useState, useRef, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import { useCountUp } from 'react-countup'
import classnames from 'classnames'

import ButtonCarousel from './../ButtonCarousel'
import TextRenderer from './../TextRenderer'
import ButtonPrimary from './../ButtonPrimary'

import 'swiper/swiper.scss'

import styles from './styles.module.scss'

const NumbersCarousel = (props) => {

    const [activeNumbersIndex, setActiveNumbersIndex] = useState(0)

    const wrapperRef = useRef(null)
    const itemRefs = useRef([])
    	
    const goPrev = () => {
        if (activeNumbersIndex - 1 < 0) {
            setActiveNumbersIndex(itemRefs.current.length - 1)
        } else {
            setActiveNumbersIndex(activeNumbersIndex - 1)
        }
    }
    
    const goNext = () => {
        if (activeNumbersIndex == props.blok.numbers.length - 1) {
            setActiveNumbersIndex(0)
        } else {
            setActiveNumbersIndex(activeNumbersIndex + 1)
        }
    }

    useEffect(() => {
        
        if (activeNumbersIndex == -1) return

        wrapperRef.current.style.height = `${itemRefs.current[activeNumbersIndex].clientHeight}px`

    }, [activeNumbersIndex])

	return (
		<SbEditable content={props.blok}>
			<section className={styles['numbers-carousel']}>
                <div className={`container ${styles['numbers-carousel__container']}`}>
                    <ButtonCarousel className={styles['numbers-carousel__button']} onClick={goPrev} />
                    <div className={styles['numbers-carousel__heading']}>
                        <TextRenderer className={'text'} text={props.blok.heading} />
                    </div>
                    <div className={styles['numbers-carousel__carousel-wrapper']}>
                        <div ref={wrapperRef} className={styles['numbers-carousel__carousel']}>
                            {props.blok.numbers.map((blok, i) => {
                                
                                const itemClasses = classnames({
                                    [styles['number-item']]: true,
                                    [styles['number-item--active']]: activeNumbersIndex == i
                                })

                                return (
                                    <SbEditable key={i} content={blok}>
                                        <div ref={el => itemRefs.current[i] = el} className={itemClasses}>
                                            <span className={`heading-1 ${styles['number-item__number']}`}><b>{blok.number}</b></span>
                                            <p className={`body`}>{blok.description}</p>
                                        </div>
                                    </SbEditable>
                                )
                            })}
                        </div>
                        {props.blok.button.map((blok) => {
                            return (
                                <SbEditable key={blok._uid} content={blok}>
                                    <ButtonPrimary label={blok.label} link={blok.link} />
                                </SbEditable>
                            )
                        })}
                    </div>
                    <ButtonCarousel className={styles['numbers-carousel__button']} onClick={goNext} />
                </div>
            </section>
		</SbEditable>
	)
}

export default NumbersCarousel
